// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"633696b4","239":"d10041ce","732":"62fba7d8"}[chunkId] + ".chunk.js";
};